import { Injectable } from '@angular/core';
import { FlagService } from '../../../core/flag.service';

@Injectable({
  providedIn: 'root'
})
export class DateService {

  constructor(private flagservice : FlagService) { }

  get defaultDateFormat(){
	  return this.flagservice.get("systemDateFormat") || 'dd/MM/yyyy';
  }
  get defaultDateTimeFormat(){
	  return 'H:mm a'; // this.flagservice.get("systemTimeFormat")
  }

  isTodayBetweenDates(start : Date, end : Date) : boolean{
		let endDate : number = this.getResetTime(new Date(end));
		let startDate : number = this.getResetTime(new Date(start));
		let today : number = this.getResetTime(new Date());

		return (!start || startDate <= today) && (!end || endDate >=  today);
	};

  isDateAfter(date1: Date, date2: Date) {
		let d1 : number = this.getResetTime(new Date(date1));
		let d2 : number = this.getResetTime(new Date(date2));

		return d1 >= d2;
	};

  isDateAfterToday = (date : Date) : boolean => this.isDateAfter(date, new Date());

  isDateBeforeToday(date : Date) : boolean{
		let d : number = this.getResetTime(new Date(date));
		let today : number = this.getResetTime(new Date());

		return d <= today;
	};

  getResetTime(date : Date) : number{
    date.setHours(0,0,0,0);
    return date.getTime();
  }
}
